import axios from 'axios';
import _ from 'lodash';

import { isMetricsValid, filterAttributes } from '../filters/index';
import { transformToCamelCase, currentRouteChannelEnabled, getCurrentRouteChannelExtra } from "../utils";
import runtime from '../utils/runtime';
import { getUrl } from "../utils/path";
import { PROMETHEUS_ENDPOINT_DOMAIN, PROMETHEUS_ENDPOINT_PATH, PROMETHEUS_ENDPOINT_NAME, UNKNOWN } from '../constants';
import logger from "../logger";

function validateMetrics(event) {
  const isValid = isMetricsValid(event.message.metrics, event.message.metricsPredicate);
  if (!isValid) {
    logger.error('不合法的 prometheus 上报数据', event)
  }

  return isValid;
}

function filterEvent(event) {
  let valid = true;
  const keys = Object.keys(event);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = event[key];

    if (typeof value === 'undefined' || value === '') {
      valid = false;
      logger.error('不合法的 prometheus 上报数据', event)
      break;
    }
  }

  return valid;
}

function formatEvent(event) {
  const { metrics, attributes } = event.message;
  const filteredAttributes = filterAttributes(PROMETHEUS_ENDPOINT_NAME, event.type, attributes);

  const transformedMetrics = transformToCamelCase(metrics);
  const transformedAttributes = transformToCamelCase(filteredAttributes);
  const { pathname, ...rest } = transformedAttributes;

  let formatted = {
    type: event.type,
    url: event.url || getUrl(),
    ...transformedMetrics,
    ...rest,
  };

  if (event.type === 'network_api') {
    // network_api 传递业务类型
    const extra = getCurrentRouteChannelExtra(PROMETHEUS_ENDPOINT_NAME);
    formatted = {
      ...formatted,
      businessType: extra.businessType || UNKNOWN,
      businessChildType: extra.businessChildType || UNKNOWN,
    };
  }

  formatted = processSpecialCases(formatted, transformedAttributes);

  return formatted;
}

function processSpecialCases(event, attributes) {
  const { pathname } = attributes;
  if (pathname) {
    event.pathName = pathname;
  }

  if (event.type === 'page_perf' && event.mode === 'ssr') {
    event.isRouteChange = 'false';
  }

  return event;
}

function getEndPointUrl() {
  const env = runtime.get('env');
  return `${PROMETHEUS_ENDPOINT_DOMAIN[env] || ''}${PROMETHEUS_ENDPOINT_PATH}`;
}

function readyTransport(events) {
  const shouldLog = runtime.get('shouldLog');
  const shouldReport = runtime.get('shouldReport');

  if (shouldLog) {
    logger.info(
`
[performance-collect]:
  endPoint: Prometheus,
  events: ${JSON.stringify(events, null, 4)}
`
    );
  }

  if (shouldReport) {
    return transport(events);
  }

  return Promise.resolve();
}

function transport(events) {
  const url = getEndPointUrl();
  return axios.post(url, events);
}

export function handleEvents(events) {
  if (!currentRouteChannelEnabled(PROMETHEUS_ENDPOINT_NAME)) {
    return Promise.resolve();
  }

  const formattedEvents = events
    .filter(validateMetrics)
    .map((event) => {
      const e = formatEvent(event)
      return e;
    })
    .filter(filterEvent);

  return readyTransport(formattedEvents);
}
